/* Shared unicare-shoppable-video controller; per-instance values are supplied by JSON configuration. */
(function () {
  if (window.UnicareShopVideos) return;
  function mount(sectionId, elementId, rootUrl) {
(function () {
    function initUnicareShopVideos() {
    var section = document.getElementById(elementId);
    if (!section || section.dataset.loaded === 'true') return;
    section.dataset.loaded = 'true';
    var shopifySection = section.closest('.shopify-section');
    var track = section.querySelector('[data-sv-track]');
    var prev = section.querySelector('[data-sv-prev]');
    var next = section.querySelector('[data-sv-next]');
    var modal = section.querySelector('[data-sv-modal]');
    var closeBtn = section.querySelector('[data-sv-close]');
    var overlay = section.querySelector('[data-sv-overlay]');
    var lazyVideoObserver;
    var unsubscribeCart;
    var previousOverflow = '';
    var lastFocusedElement = null;
    var pageActive = !document.hidden;
    var sectionUnloaded = false;
    var motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
    var hoverPreference = window.matchMedia('(hover: hover) and (pointer: fine)');
    var hoveredVideo = null;
    var activePreview = null;
    var previewVisibility = new Map();
    var mediaBindings = [];
    var currentModalIndex = -1;
    var swipeStart = null;
    var modalAnimations = [];
    var finishModalTransition = null;
    var soundButton = section.querySelector('[data-sv-sound]');
    var modalMuted = false;
    var suppressModalClickUntil = 0;
    function syncModalSound() {
      if (!soundButton) return;
      soundButton.setAttribute('aria-label', modalMuted ? 'Unmute audio' : 'Mute audio');
      var slash = soundButton.querySelector('[data-sv-sound-off]');
      if (slash) slash.style.display = modalMuted ? 'block' : 'none';
    }
    function clearModalTransition() {
      modalAnimations.forEach(function (animation) { animation.onfinish = null; animation.cancel(); });
      modalAnimations = [];
      if (finishModalTransition) finishModalTransition();
      finishModalTransition = null;
    }

    function updatePreview() {
      var selected = null;
      var ratio = 0;
      if (pageActive && !document.hidden && !sectionUnloaded && !motionPreference.matches && (!modal || modal.hidden)) {
        if (hoverPreference.matches) {
          if (hoveredVideo && previewVisibility.get(hoveredVideo) !== 0) selected = hoveredVideo;
        } else {
          previewVisibility.forEach(function (visibility, video) {
            if (video.dataset.staticPreview) return;
            if (visibility >= 0.6 && visibility > ratio) { selected = video; ratio = visibility; }
          });
        }
      }
      activePreview = selected;
      section.querySelectorAll('.unicare-sv-track video.lazy-video').forEach(function (video) {
        if (video !== selected) video.pause();
        var card = video.closest('.unicare-sv-card');
        if (card) card.classList.toggle('is-preview-playing', video === selected);
      });
      if (selected && selected.paused) {
        if (selected.dataset.src) { selected.src = selected.dataset.src; selected.removeAttribute('data-src'); selected.load(); }
        selected.muted = true;
        var promise = selected.play();
        if (promise) promise.catch(function () {});
      }
    }
    section.querySelectorAll('.unicare-sv-card').forEach(function (card) {
      var video = card.querySelector('video.lazy-video');
      if (!video) return;
      function enter() {
        if (!hoverPreference.matches) return;
        hoveredVideo = video;
        updatePreview();
      }
      function leave() {
        if (hoveredVideo === video) { hoveredVideo = null; updatePreview(); }
      }
      card.addEventListener('mouseenter', enter);
      card.addEventListener('mouseleave', leave);
      mediaBindings.push([card, 'mouseenter', enter], [card, 'mouseleave', leave]);
    });
    function onHoverChange() { hoveredVideo = null; updatePreview(); }
    if (hoverPreference.addEventListener) hoverPreference.addEventListener('change', onHoverChange);
    function onMotionChange() { updatePreview(); }
    if (motionPreference.addEventListener) motionPreference.addEventListener('change', onMotionChange);

    function mediaStatus(video, state) {
      var box = video.closest('.unicare-sv-modal-video, .unicare-sv-video-button--inline');
      var status = box && box.querySelector('[data-sv-media-status]');
      if (!status) return;
      status.hidden = !state;
      var text = status.querySelector('[data-sv-media-message]');
      var retry = status.querySelector('[data-sv-retry]');
      if (text) text.textContent = state === 'error' ? 'Video could not play. Please try again.' : 'Loading video…';
      if (retry) retry.hidden = state !== 'error';
    }
    function playModalVideo(video) {
      mediaStatus(video, 'loading');
      try {
        var promise = video.play();
        if (promise) promise.catch(function (error) {
          if (error.name !== 'AbortError' && !sectionUnloaded && pageActive && (!modal.hidden || !modal.contains(video))) mediaStatus(video, 'error');
        });
      } catch (error) { mediaStatus(video, 'error'); }
    }
    section.querySelectorAll('video').forEach(function (video) {
      var box = video.closest('.unicare-sv-modal-video, .unicare-sv-video-button--inline');
      if (!box || !box.querySelector('[data-sv-media-status]')) return;
      function loading() { mediaStatus(video, 'loading'); }
      function ready() { mediaStatus(video, ''); }
      function failed() { mediaStatus(video, 'error'); }
      [['waiting', loading], ['playing', ready], ['canplay', ready], ['error', failed]].forEach(function (binding) {
        video.addEventListener(binding[0], binding[1]);
        mediaBindings.push([video, binding[0], binding[1]]);
      });
    });
    function retryMedia(event) {
      var retry = event.target.closest('[data-sv-retry]');
      if (!retry) return;
      var box = retry.closest('.unicare-sv-modal-video, .unicare-sv-video-button--inline');
      var video = box && box.querySelector('video');
      if (!video) return;
      video.load();
      playModalVideo(video);
    }
    section.addEventListener('click', retryMedia);

    function onPageInactive() {
      clearModalTransition();
      pageActive = false;
      hoveredVideo = null;
      activePreview = null;
      section.querySelectorAll('video').forEach(function (video) { video.pause(); });
      // Provider APIs may not be ready. Close external playback instead of leaving hidden audio.
      if (modal && !modal.hidden && modal.querySelector('[data-sv-panel]:not([hidden]) iframe')) closeModal();
    }
    function onPageActive() {
      pageActive = !document.hidden;
      // Returning never automatically resumes an audible modal.
    }
    function onVisibilityChange() {
      if (document.hidden || document.visibilityState === 'hidden') onPageInactive();
      else onPageActive();
    }
    function onBlur() {
      if (typeof document.hasFocus !== 'function' || !document.hasFocus()) onPageInactive();
    }
    function guardPlayback(event) {
      var video = event.target;
      var panel = video.closest && video.closest('[data-sv-panel]');
      if ((video.classList.contains('lazy-video') && video !== activePreview) ||
          !pageActive || document.hidden || sectionUnloaded || (panel && panel.hidden) ||
          (modal && !modal.hidden && !modal.contains(video))) video.pause();
    }
    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('blur', onBlur);
    window.addEventListener('focus', onPageActive);
    window.addEventListener('pagehide', onPageInactive);
    window.addEventListener('pageshow', onPageActive);
    section.addEventListener('play', guardPlayback, true);

    function stopModalMedia(preserveFrame) {
      if (!modal) return;
      modal.querySelectorAll('video').forEach(function (video) {
        try {
          video.pause();
          if (video !== preserveFrame) video.currentTime = 0;
        } catch (e) {}
      });
      modal.querySelectorAll('iframe').forEach(function (iframe) {
        iframe.setAttribute('src', '');
      });
    }

    function openModal(index) {
      if (!modal || !pageActive || sectionUnloaded) return;
      lastFocusedElement = document.activeElement;
      previousOverflow = document.documentElement.style.overflow || '';
      currentModalIndex = -1;
      modalMuted = false;
      syncModalSound();
      stopModalMedia();

      // Elevate section stacking context so no following sections bleed over the modal backdrop
      section.classList.add('is-modal-open');
      if (shopifySection) {
        shopifySection.style.position = 'relative';
        shopifySection.style.zIndex = '999999';
      }

      // Pause all track videos to save CPU when modal is open
      section.querySelectorAll('.unicare-sv-track video').forEach(function (video) {
        try {
          video.pause();
        } catch (e) {}
      });

      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';

      if (closeBtn) {
        setTimeout(function () {
          closeBtn.focus();
        }, 50);
      }

      switchModalPanel(parseInt(index, 10) || 0);
    }

    function switchModalPanel(index) {
      var panels = modal.querySelectorAll('[data-sv-panel]');
      if (index < 0) return;
      if (index >= panels.length) { closeModal(); return; }
      clearModalTransition();
      var outgoing = modal.querySelector('[data-sv-panel="' + currentModalIndex + '"]');
      var incoming = modal.querySelector('[data-sv-panel="' + index + '"]');
      var direction = index > currentModalIndex ? 1 : -1;
      var animate = currentModalIndex >= 0 && outgoing && incoming &&
        typeof incoming.animate === 'function' &&
        window.matchMedia('(max-width: 749px)').matches && !motionPreference.matches;
      var outgoingVideo = animate ? outgoing.querySelector('video') : null;
      stopModalMedia(outgoingVideo);
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-sv-panel') !== String(index) && !(animate && panel === outgoing);
      });
      currentModalIndex = index;
      if (animate) {
        finishModalTransition = function () {
          outgoing.hidden = true;
          if (outgoingVideo) { try { outgoingVideo.currentTime = 0; } catch (error) {} }
        };
        var timing = { duration: 280, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' };
        modalAnimations = [
          outgoing.animate([{transform:'translateY(0)'}, {transform:'translateY(' + (-direction * 100) + '%)'}], timing),
          incoming.animate([{transform:'translateY(' + (direction * 100) + '%)'}, {transform:'translateY(0)'}], timing)
        ];
        modalAnimations[1].onfinish = clearModalTransition;
      }
      var activePanel = modal.querySelector('[data-sv-panel="' + index + '"]');
      if (activePanel) {
        var video = activePanel.querySelector('video');
        var iframe = activePanel.querySelector('iframe');
        if (video) {
          if (video.dataset.modalPoster && !video.getAttribute('poster')) {
            video.setAttribute('poster', video.dataset.modalPoster);
          }
          if (video.dataset.modalSrc && (!video.src || video.src === '')) {
            video.src = video.dataset.modalSrc;
            video.load();
          }
          video.muted = modalMuted;
          var progress = activePanel.querySelector('[data-sv-progress]');
          video.ontimeupdate = function () {
            var value = video.duration ? Math.round(video.currentTime / video.duration * 100) : 0;
            if (progress) {
              progress.style.width = value + '%';
              progress.parentElement.setAttribute('aria-valuenow', String(value));
            }
          };
          playModalVideo(video);
        }
        if (iframe && iframe.getAttribute('data-src')) {
          iframe.setAttribute('src', iframe.getAttribute('data-src'));
        }
      }
    }

    function closeModal() {
      if (!modal) return;
      clearModalTransition();
      swipeStart = null;
      stopModalMedia();
      modal.hidden = true;
      section.classList.remove('is-modal-open');
      if (shopifySection) {
        shopifySection.style.position = '';
        shopifySection.style.zIndex = '';
      }
      document.documentElement.style.overflow = previousOverflow;

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }

      // Resume playing visible track videos by forcing observer check
      if (lazyVideoObserver && pageActive && !sectionUnloaded) {
        section.querySelectorAll('.unicare-sv-track video').forEach(function (video) {
          try {
            lazyVideoObserver.unobserve(video);
            lazyVideoObserver.observe(video);
          } catch (e) {}
        });
      }
    }

    function onModalTouchStart(event) {
      swipeStart = null;
      if (modal.hidden || !window.matchMedia('(max-width: 749px)').matches ||
          event.touches.length !== 1 || !event.target.closest('.unicare-sv-modal-video') ||
          event.target.closest('button, a, input, summary')) return;
      swipeStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }
    function onModalTouchEnd(event) {
      var start = swipeStart; swipeStart = null;
      if (!start || modal.hidden || !event.changedTouches.length) return;
      var dx = event.changedTouches[0].clientX - start.x;
      var dy = event.changedTouches[0].clientY - start.y;
      var delta = Math.abs(dy) >= Math.abs(dx) ? dy : dx;
      if (Math.abs(delta) >= 60) {
        suppressModalClickUntil = Date.now() + 500;
        switchModalPanel(currentModalIndex + (delta < 0 ? 1 : -1));
      }
    }
    function cancelModalTouch() { swipeStart = null; }
    if (modal) {
      function toggleSound() {
        modalMuted = !modalMuted;
        var panel = modal.querySelector('[data-sv-panel="' + currentModalIndex + '"]');
        var active = panel && panel.querySelector('video');
        if (active) active.muted = modalMuted;
        syncModalSound();
      }
      if (soundButton) {
        soundButton.addEventListener('click', toggleSound);
        mediaBindings.push([soundButton, 'click', toggleSound]);
      }
      function togglePlayback(event) {
        if (Date.now() < suppressModalClickUntil || event.target.tagName !== 'VIDEO') return;
        var video = event.target;
        if (video.paused) {
          if (video.ended) video.currentTime = 0;
          playModalVideo(video);
        } else video.pause();
      }
      modal.addEventListener('click', togglePlayback);
      mediaBindings.push([modal, 'click', togglePlayback]);
      modal.addEventListener('touchstart', onModalTouchStart, { passive: true });
      modal.addEventListener('touchend', onModalTouchEnd, { passive: true });
      modal.addEventListener('touchcancel', cancelModalTouch);
      modal.querySelectorAll('[data-sv-modal-direction]').forEach(function (button) {
        function navigate() { switchModalPanel(currentModalIndex + Number(button.dataset.svModalDirection)); }
        button.addEventListener('click', navigate);
        mediaBindings.push([button, 'click', navigate]);
      });
    }

    function showFormError(form, message) {
      if (!form) return;
      var wrapper = form.closest('.unicare-sv-product-card, .unicare-sv-modal-product') || form.parentElement;
      if (!wrapper) return;
      var errorEl = wrapper.querySelector('[data-sv-error]');
      if (!errorEl) {
        errorEl = document.createElement('div');
        errorEl.className = 'unicare-sv-form-error';
        errorEl.setAttribute('data-sv-error', '');
        errorEl.setAttribute('role', 'alert');
        errorEl.setAttribute('aria-live', 'polite');
        wrapper.appendChild(errorEl);
      }
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearFormError(form) {
      if (!form) return;
      var wrapper = form.closest('.unicare-sv-product-card, .unicare-sv-modal-product') || form.parentElement;
      if (!wrapper) return;
      var errorEl = wrapper.querySelector('[data-sv-error]');
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
    }

    if (track && prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({
          left: -track.clientWidth * 0.8,
          behavior: 'smooth'
        });
      });
    }

    if (track && next) {
      next.addEventListener('click', function () {
        track.scrollBy({
          left: track.clientWidth * 0.8,
          behavior: 'smooth'
        });
      });
    }

    // Drag to scroll with snap-type toggling and clean click suppression
    var isDown = false;
    var startX;
    var scrollLeft;
    var hasMoved = false;

    if (track) {
      track.addEventListener('mousedown', function (e) {
        isDown = true;
        hasMoved = false;
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
      });

      track.addEventListener('mouseleave', function () {
        if (isDown) {
          isDown = false;
          track.style.scrollSnapType = 'x mandatory';
          track.style.scrollBehavior = 'smooth';
        }
        if (hasMoved) {
          setTimeout(function () {
            hasMoved = false;
          }, 0);
        }
      });

      track.addEventListener('mouseup', function () {
        if (isDown) {
          isDown = false;
          track.style.scrollSnapType = 'x mandatory';
          track.style.scrollBehavior = 'smooth';
        }
        if (hasMoved) {
          setTimeout(function () {
            hasMoved = false;
          }, 0);
        }
      });

      track.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var x = e.pageX - track.offsetLeft;
        var walk = (x - startX) * 1.5;
        if (Math.abs(walk) > 5) {
          hasMoved = true;
          e.preventDefault();
        }
        track.scrollLeft = scrollLeft - walk;
      });
    }

    section.addEventListener('click', function (event) {
      var openButton = event.target.closest('[data-sv-open]');
      if (openButton) {
        if (hasMoved) {
          event.preventDefault();
          event.stopPropagation();
          hasMoved = false;
          return;
        }
        event.preventDefault();
        openModal(openButton.getAttribute('data-modal-index'));
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }
    if (overlay) {
      overlay.addEventListener('click', closeModal);
    }

    // Dedicated Buy Now instant checkout redirect handler (single explicit selector)
    section.addEventListener('click', function (e) {
      var buyNowBtn = e.target.closest('[data-action="buy-now"]');
      if (!buyNowBtn) return;

      var form = buyNowBtn.closest('form');
      if (!form) return;

      e.preventDefault();
      e.stopPropagation();

      if (buyNowBtn.classList.contains('loading') || buyNowBtn.getAttribute('aria-disabled') === 'true') {
        return;
      }

      clearFormError(form);
      buyNowBtn.classList.add('loading');
      buyNowBtn.setAttribute('aria-disabled', 'true');

      var isThemeEditor = Boolean(
        (window.Shopify && window.Shopify.designMode) ||
        (window.self !== window.top)
      );

      var editorCheckoutTab = null;
      if (isThemeEditor) {
        try {
          editorCheckoutTab = window.open('about:blank', '_blank');
        } catch (err) {
          console.warn('Unable to pre-open checkout tab in editor:', err);
        }
      }

      var formData = new FormData(form);
      var variantId = formData.get('id');
      var quantity = parseInt(formData.get('quantity'), 10) || 1;

      if (!variantId) {
        if (editorCheckoutTab) {
          try { editorCheckoutTab.close(); } catch (err) {}
        }
        buyNowBtn.classList.remove('loading');
        buyNowBtn.removeAttribute('aria-disabled');
        showFormError(form, 'Please select a variant to proceed.');
        return;
      }

      var rootUrl = (window.routes && window.routes.root_url) ? window.routes.root_url : '/';
      var cleanRoot = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';
      var directCheckoutUrl = cleanRoot + 'cart/' + variantId + ':' + quantity;

      if (isThemeEditor && editorCheckoutTab) {
        try {
          editorCheckoutTab.location.href = directCheckoutUrl;
          return;
        } catch (err) {
          window.location.href = directCheckoutUrl;
          return;
        }
      } else {
        window.location.href = directCheckoutUrl;
        return;
      }
    }, true);

    // Keydown event listener with visible-only focus trapping and self-cleaning behavior
    function onKeyDown(event) {
      if (!document.contains(section)) {
        document.removeEventListener('keydown', onKeyDown);
        return;
      }
      if (!modal || modal.hidden) return;

      if (event.key === 'Escape') {
        closeModal();
        return;
      }
      if ((event.key === 'ArrowRight' || event.key === 'ArrowLeft') &&
          !event.target.closest('input, textarea, select, video')) {
        event.preventDefault();
        switchModalPanel(currentModalIndex + (event.key === 'ArrowRight' ? 1 : -1));
        return;
      }

      if (event.key === 'Tab') {
        var rawFocusable = modal.querySelectorAll(
          'button:not([disabled]), a[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        var focusable = Array.prototype.filter.call(rawFocusable, function (el) {
          return !el.hidden && !el.closest('[hidden]') && el.offsetParent !== null;
        });
        if (focusable.length > 0) {
          var firstEl = focusable[0];
          var lastEl = focusable[focusable.length - 1];

          if (event.shiftKey) {
            if (document.activeElement === firstEl || !modal.contains(document.activeElement)) {
              event.preventDefault();
              lastEl.focus();
            }
          } else {
            if (document.activeElement === lastEl || !modal.contains(document.activeElement)) {
              event.preventDefault();
              firstEl.focus();
            }
          }
        }
      }
    }
    document.addEventListener('keydown', onKeyDown);

    // Choose one sufficiently visible preview; never start all visible videos.
    if ('IntersectionObserver' in window) {
      lazyVideoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { previewVisibility.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0); });
        updatePreview();
      }, { threshold: [0, 0.6, 1] });
      section.querySelectorAll('.unicare-sv-track video.lazy-video').forEach(function (video) {
        lazyVideoObserver.observe(video);
      });
    }

    // Dynamic navigation arrow visibility toggle
    function updateArrowVisibility() {
      if (!track || !prev || !next) return;
      var isScrollable = track.scrollWidth > (track.clientWidth + 30);
      if (isScrollable) {
        prev.style.display = '';
        next.style.display = '';
      } else {
        prev.style.display = 'none';
        next.style.display = 'none';
      }
    }
    updateArrowVisibility();
    setTimeout(updateArrowVisibility, 100);
    setTimeout(updateArrowVisibility, 500);

    function onResize() {
      if (!document.contains(section)) {
        window.removeEventListener('resize', onResize);
        return;
      }
      updateArrowVisibility();
    }
    window.addEventListener('resize', onResize, { passive: true });

    // Automatically close video modal when an item is added to cart, revealing cart drawer
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        if (modal && !modal.hidden) {
          closeModal();
        }
      });
    }

    function cleanupSection(event) {
      if (event.detail.sectionId !== sectionId) return;
      sectionUnloaded = true;
      onPageInactive();
      if (modal && !modal.hidden) closeModal();
      stopModalMedia();
      if (unsubscribeCart) unsubscribeCart();
      window.removeEventListener('resize', onResize);
      if (lazyVideoObserver) lazyVideoObserver.disconnect();
      if (modal) {
        modal.removeEventListener('touchstart', onModalTouchStart);
        modal.removeEventListener('touchend', onModalTouchEnd);
        modal.removeEventListener('touchcancel', cancelModalTouch);
      }
      previewVisibility.clear();
      if (hoverPreference.removeEventListener) hoverPreference.removeEventListener('change', onHoverChange);
      if (motionPreference.removeEventListener) motionPreference.removeEventListener('change', onMotionChange);
      section.removeEventListener('click', retryMedia);
      mediaBindings.forEach(function (binding) { binding[0].removeEventListener(binding[1], binding[2]); });
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.removeEventListener('blur', onBlur);
      window.removeEventListener('focus', onPageActive);
      window.removeEventListener('pagehide', onPageInactive);
      window.removeEventListener('pageshow', onPageActive);
      section.removeEventListener('play', guardPlayback, true);
      document.removeEventListener('shopify:section:unload', cleanupSection);
      delete section.dataset.loaded;
    }
    document.addEventListener('shopify:section:unload', cleanupSection);
    }
    var reloadKey = 'unicare-shopvideos-reload-' + sectionId;
    if (window[reloadKey]) document.removeEventListener('shopify:section:load', window[reloadKey]);
    window[reloadKey] = function(event) {
      if (event.detail.sectionId === sectionId) initUnicareShopVideos();
    };
    document.addEventListener('shopify:section:load', window[reloadKey]);
    initUnicareShopVideos();
  })();

  }
  window.UnicareShopVideos = { mount: mount };
  function scan(scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('script[data-unicare-shopvideos-config]').forEach(function (config) {
      if (config.dataset.controllerLoaded === 'true') return;
      try {
        var values = JSON.parse(config.textContent);
        config.dataset.controllerLoaded = 'true';
        mount(values.sectionId, values.elementId, values.rootUrl || '/');
      } catch (error) {
        console.warn('[Unicare] Invalid video section configuration', error);
      }
    });
  }
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else {
    scan(document);
  }
})();
